<template>
  <div>
    <v-app-bar
      id="core-app-bar"
      class="hidden-print-only"
      absolute
      app
      color="transparent"
      flat
      height="88"
    >
      <v-toolbar-title class="tertiary--text font-weight-light align-self-center">
        <v-btn
          v-if="responsive"
          dark
          icon
          @click.stop="onClick"
        >
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ title }}
      </v-toolbar-title>

      <v-spacer />

      <v-toolbar-items>
        <v-row
          align="center"
          class="mx-0"
        >
          <v-btn
            icon
            to="/"
          >
            <v-icon color="tertiary">
              mdi-view-dashboard
            </v-icon>
          </v-btn>

          <v-menu
            bottom
            left
            offset-y
            transition="slide-y-transition"
          >
            <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                >
                  mdi-account
                </v-icon>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in items"
                :key="index"
                @click="menuAction(item.title)"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-row>
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>

<script>
// Utilities
import {
  mapMutations,
} from 'vuex';

export default {
  data: () => ({
    items: [
      {
        title: 'My Account',
      },
      {
        title: 'Log Off',
      },
    ],
    title: null,
    responsive: false,
  }),

  watch: {
    $route(val) {
      this.title = val.name;
    },
  },

  mounted() {
    this.onResponsiveInverted();
    window.addEventListener('resize', this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResponsiveInverted);
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onClick() {
      this.setDrawer(!this.$store.state.app.drawer);
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    menuAction(title) {
      // eslint-disable-next-line default-case
      switch (title) {
        case 'Log Off':
          this.$auth.logout();
          window.location = '/login';
          break;
        case 'My Account':
          this.$router.push({ path: '/user-account' });
          break;
      }
    },
  },
};
</script>

<style>
  /* Fix coming in v2.0.8 */
  #core-app-bar {
    width: auto;
  }

  #core-app-bar a {
    text-decoration: none;
  }
</style>
